import React from 'react';
import { Autocomplete, Button, FormControl, TextField } from '@mui/material';
import { ArrowDropDown } from '@mui/icons-material';
import AddIcon from '@mui/icons-material/Add';

const PLACEHOLDER_ID = -123456;

const AddNewWorkItemDialog = ({
  // data
  workflowItems = [],
  actionItems = [],
  iccItems = [],
  formValues,
  dialogFormState,
  iccEnabled,
  // handlers
  onWorkflowChange,   // (event, newValue, reason) => void
  onActionTypeChange, // (event, newValue, reason) => void
  onICCChange,        // (event, newValue, reason) => void
  onSubmit,           // () => void
}) => {

  const selectedWorkflow =
    (formValues.workflowItemSelect?.workflowID &&
      formValues.workflowItemSelect.workflowID !== PLACEHOLDER_ID)
      ? workflowItems.find(opt => opt.workflowID === formValues.workflowItemSelect.workflowID) ?? null
      : null;

  const selectedActionType =
    (formValues.actionTypeSelectedItem?.actionTypeID &&
      formValues.actionTypeSelectedItem.actionTypeID !== PLACEHOLDER_ID)
      ? actionItems.find(opt => opt.actionTypeID === formValues.actionTypeSelectedItem.actionTypeID) ?? null
      : null;

  const selectedICC =
    (formValues.iccSelect?.iccTypeID &&
      formValues.iccSelect.iccTypeID !== PLACEHOLDER_ID)
      ? iccItems.find(opt => opt.iccTypeID === formValues.iccSelect.iccTypeID) ?? null
      : null;

  const handleWorkflowChange = (event, newValue, reason) => {
    const modifiedEvent = { target: { name: 'workflowItemSelect' } };
    onWorkflowChange(modifiedEvent, newValue, reason);
  };

  const handleActionTypeChange = (event, newValue, reason) => {
    const modifiedEvent = { target: { name: 'actionTypeSelectedItem' } };
    onActionTypeChange(modifiedEvent, newValue, reason);
  };

  const handleICCChange = (event, newValue, reason) => {
    const modifiedEvent = { target: { name: 'iccSelect' } };
    onICCChange(modifiedEvent, newValue, reason);
  };

  return (
    <div className='flex-main-frame'>
      <div className='form-content' style={{ width: '100%' }}>
        <div className='form-dynamic-content'>
          <form className='form-dynamic-grid'>

            {/* Workflow */}
            <div className='form-row'>
              <div className='form-group'>
                <FormControl fullWidth>
                  <Autocomplete
                    options={workflowItems}
                    getOptionLabel={(option) => option.workflowName || ''}
                    isOptionEqualToValue={(option, value) => option.workflowID === value?.workflowID}
                    id='workflowItemSelect'
                    value={selectedWorkflow}
                    disabled={!dialogFormState.workflowEnabled}
                    iconcomponent={ArrowDropDown}
                    label='Workflow'
                    noOptionsText='Workflow not found'
                    onChange={handleWorkflowChange}
                    disablePortal
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label='Workflow'
                        variant='outlined'
                        InputLabelProps={{ shrink: true }}
                      />
                    )}
                  />
                </FormControl>
              </div>
            </div>

            {/* Action Type */}
            <div className='form-row'>
              <div className='form-group'>
                <FormControl fullWidth>
                  <Autocomplete
                    options={actionItems}
                    getOptionLabel={(option) => option.actionType || ''}
                    isOptionEqualToValue={(option, value) => option.actionTypeID === value?.actionTypeID}
                    id='actionTypeSelectedItem'
                    value={selectedActionType}
                    disabled={!dialogFormState.actionTypeEnabled}
                    iconcomponent={ArrowDropDown}
                    label='Action Type'
                    noOptionsText='Action Type not found'
                    onChange={handleActionTypeChange}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label='Action Type'
                        variant='outlined'
                        InputLabelProps={{ shrink: true }}
                      />
                    )}
                  />
                </FormControl>
              </div>
            </div>

            {/* ICC (conditional) */}
            {iccEnabled && (
              <div className='form-row'>
                <div className='form-group'>
                  <FormControl fullWidth>
                    <Autocomplete
                      options={iccItems}
                      getOptionLabel={(option) => option.dropdownName || ''}
                      isOptionEqualToValue={(option, value) => option.iccTypeID === value?.iccTypeID}
                      id='iccSelect'
                      value={selectedICC}
                      disabled={!dialogFormState.iccEnabled}
                      iconcomponent={ArrowDropDown}
                      label='ICC'
                      noOptionsText='ICC not found'
                      onChange={handleICCChange}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label='ICC'
                          variant='outlined'
                          InputLabelProps={{ shrink: true }}
                        />
                      )}
                    />
                  </FormControl>
                </div>
              </div>
            )}

            {/* Submit */}
            <div className='form-row'>
              <div className='form-group'>
                <div className='d-flex justify-content-between align-items-center mb-2 form-actions'>
                  <div className='centerDiv text-wrapper-message'>
                    <Button
                      id='addWorkItemBtn'
                      name='addWorkItemBtn'
                      variant='contained'
                      color='ywButtonBlue'
                      className='me-3'
                      disabled={!dialogFormState.addWorkItemButtonEnabled}
                      onClick={onSubmit}
                    >
                      <AddIcon />ADD WORK ITEM
                    </Button>
                  </div>
                </div>
              </div>
            </div>

          </form>
        </div>
      </div>
    </div>
  );
};

export default React.memo(AddNewWorkItemDialog);